import type React from "react";
import ReactDOM from "react-dom";
import close from "~/images/close.svg";
import styles from "./index.module.scss";

interface ModalProps {
  label: string;
  isOpen: boolean;
  onClose: () => void;
  content: React.ReactNode;
  className?: string;
  showCloseButton?: boolean;
  usePortal?: boolean;
  footer?: React.ReactNode;
  titleRight?: React.ReactNode;
  subHeader?: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({
  label,
  isOpen,
  onClose,
  content,
  className,
  showCloseButton = true,
  usePortal = false,
  footer,
  titleRight,
  subHeader,
}) => {
  if (!isOpen) return null;

  const overlayClass =
    className && styles[className]
      ? `${styles["overlay"]} ${styles[className]}`
      : styles["overlay"];

  const modalContent = (
    <div className={overlayClass}>
      <div className={styles["modal"]}>
        <div className={styles["modalTitle"]}>
          <h2 className={styles["modalTitleText"]}>{label}</h2>
          {titleRight && <div className={styles["modalTitleRight"]}>{titleRight}</div>}
          {showCloseButton && (
            <div
              className={styles["closeButton"]}
              onClick={onClose}
              data-testid="modal-close-button"
            >
              <img src={close} alt="" />
            </div>
          )}
        </div>

        {subHeader && <div className={styles["subHeader"]}>{subHeader}</div>}

        <div className={styles["content"]}>{content}</div>
        {footer}
      </div>
    </div>
  );

  if (usePortal) {
    return ReactDOM.createPortal(modalContent, document.body);
  }

  return modalContent;
};

export default Modal;
